import * as React from 'react';
import { PaymentMethods } from './PaymentMethods';
import { useSelector } from 'react-redux';
import {
  selectIsPaymentMethodsVisible,
  selectIsSinglePaymentMethodAvailable,
  selectPaymentMethodsIds,
} from '../../../selectors/paymentMethods';
import { PaymentMethodContainer } from '../PaymentMethod';
import { getTitle } from './utils';

export const PaymentMethodsContainer = () => {
  const isVisible = useSelector(selectIsPaymentMethodsVisible);
  const isSingleMethodAvailable = useSelector(selectIsSinglePaymentMethodAvailable);
  const methodsIds = useSelector(selectPaymentMethodsIds);

  const title = getTitle(isSingleMethodAvailable);

  const methods = methodsIds.map((id, index) => <PaymentMethodContainer id={id} key={index} />);

  if (!isVisible) {
    return null;
  }

  return <PaymentMethods title={title} methods={methods} />;
};
